module.exports = __webpack_public_path__ + "media/profile/cert-bb4cb718.png";